'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import keyMirror from 'react-utils/keyMirror';
import emptyFunction from 'react-utils/emptyFunction';
import * as CustomWidgetFieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { getDefaultScalarValue } from 'ContentUtils/helpers/FieldHelpers';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { MODULE_DATA_VALIDATION_REQUIRED_FIELD_MISSING, MODULE_DATA_VALIDATION_LOCKED_REQUIRED_FIELD_MISSING } from 'DesignData/enums/CustomWidgetFieldWarningTypes';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TextContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/TextContentOptions';
import RichTextContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/RichTextContentOptions';
import BooleanContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/BooleanContentOptions';
import ChoiceContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/ChoiceContentOptions';
import NumberContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/NumberContentOptions';
import DateContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/DateContentOptions';
import DateTimeContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/DateTimeContentOptions';
import ColorContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/ColorContentOptions';
import CtaContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/CtaContentOptions';
import IconContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/IconContentOptions';
import ImageContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/ImageContentOptions';
import FileContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/FileContentOptions';
import HtmlContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/HtmlContentOptions';
import SimpleMenuContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/SimpleMenuContentOptions';
import LogoContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/LogoContentOptions';
import FullScreenEditButton from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FullScreenEditButton';
import FollowupEmailContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/FollowupEmailContentOptions';
import FontContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/FontContentOptions';
import GenericContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/GenericContentOptions';
import TagContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/TagContentOptions';
import UrlContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/UrlContentOptions';
import VideoContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/VideoContentOptions';
import FormContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/FormContentOptions';
import CrmObjectContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/CrmObjectContentOptions';
import CrmObjectPropertyContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/CrmObjectPropertyContentOptions';
import GradientContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/GradientContentOptions';
import SpacingContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/SpacingContentOptions';
import BackgroundImageContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/BackgroundImageContentOptions';
import EmbedContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/EmbedContentOptions';
import HubDbRowContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/HubDbRowContentOptions';
import BorderContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/BorderContentOptions';
import AlignmentContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/AlignmentContentOptions';
import TextAlignmentContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/TextAlignmentContentOptions';
const FIELD_COMPONENTS = {
  [CustomWidgetFieldTypes.TEXT]: TextContentOptions,
  [CustomWidgetFieldTypes.RICH_TEXT]: RichTextContentOptions,
  [CustomWidgetFieldTypes.BOOLEAN]: BooleanContentOptions,
  [CustomWidgetFieldTypes.CHOICE]: ChoiceContentOptions,
  [CustomWidgetFieldTypes.NUMBER]: NumberContentOptions,
  [CustomWidgetFieldTypes.DATE]: DateContentOptions,
  [CustomWidgetFieldTypes.DATE_TIME]: DateTimeContentOptions,
  [CustomWidgetFieldTypes.COLOR]: ColorContentOptions,
  [CustomWidgetFieldTypes.CTA]: CtaContentOptions,
  [CustomWidgetFieldTypes.IMAGE]: ImageContentOptions,
  [CustomWidgetFieldTypes.FILE]: FileContentOptions,
  [CustomWidgetFieldTypes.BLOG]: GenericContentOptions,
  [CustomWidgetFieldTypes.TAG]: TagContentOptions,
  [CustomWidgetFieldTypes.FORM]: FormContentOptions,
  [CustomWidgetFieldTypes.WORKFLOW]: GenericContentOptions,
  [CustomWidgetFieldTypes.FOLLOW_UP_EMAIL]: FollowupEmailContentOptions,
  [CustomWidgetFieldTypes.EMAIL]: GenericContentOptions,
  [CustomWidgetFieldTypes.HUBDB_TABLE]: GenericContentOptions,
  [CustomWidgetFieldTypes.PAGE]: GenericContentOptions,
  [CustomWidgetFieldTypes.MENU]: GenericContentOptions,
  [CustomWidgetFieldTypes.HUBL]: HtmlContentOptions,
  [CustomWidgetFieldTypes.HTML]: HtmlContentOptions,
  [CustomWidgetFieldTypes.MEETING]: GenericContentOptions,
  [CustomWidgetFieldTypes.SIMPLE_MENU]: SimpleMenuContentOptions,
  [CustomWidgetFieldTypes.LOGO]: LogoContentOptions,
  [CustomWidgetFieldTypes.ICON]: IconContentOptions,
  [CustomWidgetFieldTypes.SFDC_CAMPAIGN]: GenericContentOptions,
  [CustomWidgetFieldTypes.SURVEY]: GenericContentOptions,
  [CustomWidgetFieldTypes.FONT]: FontContentOptions,
  [CustomWidgetFieldTypes.URL]: UrlContentOptions,
  [CustomWidgetFieldTypes.LINK]: UrlContentOptions,
  [CustomWidgetFieldTypes.VIDEO]: VideoContentOptions,
  [CustomWidgetFieldTypes.CRM_OBJECT]: CrmObjectContentOptions,
  [CustomWidgetFieldTypes.CRM_OBJECT_PROPERTY]: CrmObjectPropertyContentOptions,
  [CustomWidgetFieldTypes.GRADIENT]: GradientContentOptions,
  [CustomWidgetFieldTypes.SPACING]: SpacingContentOptions,
  [CustomWidgetFieldTypes.BACKGROUND_IMAGE]: BackgroundImageContentOptions,
  [CustomWidgetFieldTypes.EMBED]: EmbedContentOptions,
  [CustomWidgetFieldTypes.HUBDB_ROW]: HubDbRowContentOptions,
  [CustomWidgetFieldTypes.BORDER]: BorderContentOptions,
  [CustomWidgetFieldTypes.ALIGNMENT]: AlignmentContentOptions,
  [CustomWidgetFieldTypes.TEXT_ALIGNMENT]: TextAlignmentContentOptions,
  [CustomWidgetFieldTypes.PAYMENT]: GenericContentOptions
};
const FULL_SCREEN_FIELD_TYPES = keyMirror({
  [CustomWidgetFieldTypes.SIMPLE_MENU]: null,
  [CustomWidgetFieldTypes.RICH_TEXT]: null,
  [CustomWidgetFieldTypes.HTML]: null,
  [CustomWidgetFieldTypes.HUBL]: null
});
export default class ContentOptions extends PureComponent {
  renderMissingRequiredDefaultWarning() {
    const {
      fieldWarnings
    } = this.props;
    const defaultWarnings = fieldWarnings && fieldWarnings[DEFAULT];
    if (!defaultWarnings || !defaultWarnings.length) return null;
    const missingRequiredDefaultWarning = defaultWarnings.find(warning => warning.type === MODULE_DATA_VALIDATION_REQUIRED_FIELD_MISSING || warning.type === MODULE_DATA_VALIDATION_LOCKED_REQUIRED_FIELD_MISSING);
    return missingRequiredDefaultWarning && /*#__PURE__*/_jsx(UIAlert, {
      className: "m-bottom-2",
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `DesignEditorsUI.customWidgetEditor.errors.field.${missingRequiredDefaultWarning.type}`
      })
    });
  }

  render() {
    const {
      compact,
      customWidgetContentTypes,
      customWidgetHostTemplateTypes,
      customWidgetId,
      editField,
      field,
      fieldErrors,
      fieldWarnings,
      isEmailOrAnyType,
      isV1,
      onPreviewClick,
      readOnly
    } = this.props;
    const FieldComponent = FIELD_COMPONENTS[field.type];
    const fieldWithDefaultScalar = field.set('default', getDefaultScalarValue(field));

    if (compact && FULL_SCREEN_FIELD_TYPES[field.type]) {
      return /*#__PURE__*/_jsx(FullScreenEditButton, {
        customWidgetId: customWidgetId,
        field: field,
        readOnly: readOnly
      });
    }

    if (FieldComponent) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [this.renderMissingRequiredDefaultWarning(), /*#__PURE__*/_jsx(FieldComponent, {
          compact: compact,
          customWidgetId: customWidgetId,
          isV1: isV1,
          editField: editField,
          field: fieldWithDefaultScalar,
          fieldErrors: fieldErrors,
          fieldWarnings: fieldWarnings,
          contentTypes: customWidgetContentTypes,
          hostTemplateTypes: customWidgetHostTemplateTypes,
          readOnly: readOnly,
          onPreviewClick: onPreviewClick,
          isEmail: isEmailOrAnyType
        })]
      });
    }

    return null;
  }

}
ContentOptions.propTypes = {
  customWidgetContentTypes: PropTypes.array,
  customWidgetHostTemplateTypes: PropTypes.array,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  fieldWarnings: PropTypes.object,
  compact: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  isV1: PropTypes.bool.isRequired,
  onPreviewClick: PropTypes.func,
  isEmailOrAnyType: PropTypes.bool.isRequired
};
ContentOptions.defaultProps = {
  customWidgetContentTypes: null,
  customWidgetHostTemplateTypes: null,
  fieldErrors: {},
  fieldWarnings: {},
  compact: false,
  onPreviewClick: emptyFunction
};